import {Html} from "@react-three/drei";
import React from "react";
import {InfoButton} from "web-vcore";
import {Vec3} from "../ThreeJS/VectorStructs.js";

// use the ErrorBoundary from sentry atm (haven't tested web-vcore's in r3 canvas yet)
//import {ErrorBoundary} from "web-vcore";
import {ErrorBoundary} from "@sentry/react";

export type ErrorBoundaryR3 = {message?: string|n, position: Vec3} & React.ComponentPropsWithoutRef<typeof ErrorBoundary>;
export const ErrorBoundaryR3 = (props: ErrorBoundaryR3)=>{
	const {message = "Error while rendering", position, fallback, ...rest} = props;
	const fallback_default = data=>{
		return (
			<Html position={position.To3JPos()}>
				<div style={{color: "red"}}>
					{message}
					<InfoButton ml={5} text={data.error?.toString() ?? "Error not available."}/>
				</div>
			</Html>
		);
	};
	return <ErrorBoundary {...rest} fallback={fallback ?? fallback_default}/>;
};